import { $t } from "@/lib/i18nHelpers";
import { CryptoButton } from "../../";

export const systemName = "bitcoin_p2p";

export const cryptoPageTitle = $t("Pay in bitcoin");

export const cryptoButton: CryptoButton = {
  name: systemName,
  title: $t("Pay with Bitcoin"),
  icon: "sci-color-bitcoin",
};
